/*
 * Copyright (C) 2017 - present Instructure, Inc.
 *
 * This file is part of Canvas.
 *
 * Canvas is free software: you can redistribute it and/or modify it under
 * the terms of the GNU Affero General Public License as published by the Free
 * Software Foundation, version 3 of the License.
 *
 * Canvas is distributed in the hope that it will be useful, but WITHOUT ANY
 * WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR
 * A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
 * details.
 *
 * You should have received a copy of the GNU Affero General Public License along
 * with this program. If not, see <http://www.gnu.org/licenses/>.
 */

import type {Assignment} from '../../api'
import replaceTags from '@canvas/util/replaceTags'

class DownloadSubmissionsDialogManager {
  assignment: Pick<Assignment, 'id' | 'submission_types' | 'has_submitted_submissions'>

  downloadUrl: string

  validSubmissionTypes = ['online_upload', 'online_text_entry', 'online_url']

  submissionsDownloading: (assignmentId: string) => void

  constructor(
    assignment: Pick<Assignment, 'id' | 'submission_types' | 'has_submitted_submissions'>,
    downloadUrlTemplate: string,
    submissionsDownloading: (assignmentId: string) => void,
  ) {
    this.assignment = assignment
    this.downloadUrl = replaceTags(downloadUrlTemplate, 'assignment_id', assignment.id)
    this.showDialog = this.showDialog.bind(this)
    this.submissionsDownloading = submissionsDownloading
  }

  isDialogEnabled() {
    return (
      this.assignment.submission_types &&
      this.assignment.submission_types.some(t => this.validSubmissionTypes.includes(t)) &&
      this.assignment.has_submitted_submissions
    )
  }

  showDialog(cb: () => void) {
    this.submissionsDownloading(this.assignment.id)

    ;(
      window as unknown as {INST: {downloadSubmissions: (url: string, cb: () => void) => void}}
    ).INST.downloadSubmissions(this.downloadUrl, cb)
  }
}

export default DownloadSubmissionsDialogManager
